import { ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
// NOTE: Looking for Screen & Media Querying? ScreenService is located in common/ui!
export let LayoutService = /*#__PURE__*/(() => {
  class LayoutService {
    constructor(config, router) {
      this.config = config;
      // Window-size based observables have been moved to @common/ui/frontend-shared/screen-servie!
      this.layoutMode$ = new BehaviorSubject([]); // always lowercase!
      this.fullScreenView = new BehaviorSubject(false);
      this.fullscreenView$ = this.fullScreenView.asObservable();
      this.setupRouteSubscription(router);
    }
    setupRouteSubscription(router) {
      // ActivationEnd will be emitted several times depending on depth of route.
      // to fix, set activationHandled to true and skip further ActivationEnd events.
      // Listen to NavigationEnd and reset the variable then.
      let activationHandled = false;
      const activationEndEvents = router.events.pipe(filter(event => event instanceof ActivationEnd));
      router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(val => {
        activationHandled = false;
      });
      activationEndEvents.subscribe(e => {
        if (!activationHandled) {
          activationHandled = true;
          let layoutInstruction = '';
          let snapshot = e.snapshot;
          while (snapshot) {
            if (snapshot.data['layout']) {
              layoutInstruction = snapshot.data['layout'];
              break;
            }
            snapshot = snapshot.parent;
          }
          this.setLayout(layoutInstruction);
        }
      });
    }
    setLayout(layout) {
      if (!Array.isArray(layout)) {
        layout = layout.split(/[,\s]/);
      }
      layout = layout.map(entry => entry.toLowerCase());
      this.layoutMode$.next(layout);
      this.setFullscreen(layout.indexOf('fullscreen') > -1);
    }
    setFullscreen(state) {
      if (this.fullScreenView.value !== state) this.fullScreenView.next(state);
    }
    static {
      this.ɵfac = function LayoutService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutService)(i0.ɵɵinject('LAYOUT_CONFIG_PROVIDER'), i0.ɵɵinject(i1.Router));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: LayoutService,
        factory: LayoutService.ɵfac
      });
    }
  }
  return LayoutService;
})();